import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape, propNumber, propStr, } from '../../../../helpers/custom-prop-types';
import Image from '../../../Ui/Common/Image';
const assignText = {
    1: '今すぐ可能',
    2: '対応時期調整',
    3: '対応不可',
};
const unitTimeText = {
    1: '日',
    2: '時間',
};
const onSiteText = {
    1: '可能',
    2: '不可',
    3: '要相談',
};
const ProfessionalProfile = (props) => {
    const { assignable, experienceList, experiencedIndustryClasses, file, onSite, situation, unitTime, userId, } = props;
    const showAssignText = assignText[situation];
    const showUnitTime = unitTimeText[unitTime];
    const showOnSiteText = onSiteText[onSite];
    return (_jsxs("div", Object.assign({ className: 'l-about-left is-free' }, { children: [_jsx("div", Object.assign({ className: 'about-image is-free' }, { children: _jsx(Image, { allowContextMenu: false, alt: '', isObjectFit: true, noImageType: 'user', src: file }) })), _jsxs("dl", Object.assign({ className: 'about-profile' }, { children: [experienceList.length > 0 && (_jsxs(_Fragment, { children: [_jsx("dt", { children: "\u7D4C\u9A13" }), _jsx("dd", { children: _jsx("div", Object.assign({ className: 'is-flex-wrap-row' }, { children: experienceList.map((v) => (_jsx("span", Object.assign({ className: 'is-like-link is-nowrap' }, { children: `#${v.name}` }), v.id))) })) })] })), experiencedIndustryClasses.length > 0 && (_jsxs(_Fragment, { children: [_jsx("dt", { children: "\u696D\u7A2E" }), _jsx("dd", { children: experiencedIndustryClasses.map((v) => v.name).join('、') })] })), showAssignText && assignable && showUnitTime && (_jsxs(_Fragment, { children: [_jsx("dt", { children: "\u30A2\u30B5\u30A4\u30F3" }), _jsxs("dd", { children: [showAssignText && (_jsx("span", Object.assign({ className: 'is-nowrap mr10' }, { children: showAssignText }))), assignable && showUnitTime && (_jsxs("span", Object.assign({ className: 'is-nowrap' }, { children: [_jsxs("span", Object.assign({ className: 'fw-500' }, { children: ["\u7D04", _jsx("span", Object.assign({ className: 'fs-18' }, { children: assignable })), showUnitTime] })), "/\u6708"] })))] })] })), showOnSiteText && (_jsxs(_Fragment, { children: [_jsx("dt", Object.assign({ className: 'is-nowrap' }, { children: "\u5E38\u99D0\u53EF\u5426" })), _jsx("dd", Object.assign({ className: 'is-nowrap' }, { children: onSiteText[onSite] }))] })), _jsx("dt", Object.assign({ className: 'is-nowrap' }, { children: "\u30E6\u30FC\u30B6\u30FCID" })), _jsx("dd", Object.assign({ className: 'is-nowrap' }, { children: `0000${userId}`.slice(-4) }))] }))] })));
};
ProfessionalProfile.propTypes = {
    assignable: propNumber(),
    experienceList: propArrayShape().isRequired,
    experiencedIndustryClasses: propArrayShape().isRequired,
    file: propStr(),
    onSite: propNumber(),
    situation: propNumber(),
    unitTime: propNumber(),
    userId: propNumber(),
};
ProfessionalProfile.defaultProps = {
    assignable: undefined,
    file: '',
    onSite: undefined,
    situation: undefined,
    unitTime: undefined,
    userId: undefined,
};
export default ProfessionalProfile;
